import PropTypes from 'prop-types';
import React from 'react';
import { Button, Flex, Text } from 'rebass';
import styled from 'styled-components';
import AnimatedContainer from './AnimatedContainer';

Button.defaultProps = {
  ...Button.defaultProps,
  px: null,
  py: null,
};

const ToggleButton = styled(Button)`
  background-color: white;
  border-radius: 0;
  border: 1px solid black;
  color: black;
  cursor: pointer;

  div {
    border-bottom: 2px transparent solid;
    display: inline;
    transition: border 0.3s ease-in-out;
  }

  &.active {
    background-color: black;
    color: white;
  }

  &:hover div {
    border-color: black;
  }

  &.active:hover div {
    border-color: transparent;
  }
`;

const BookingToggle = ({
  activeItem,
  firstItem,
  secondItem,
  setActiveItem,
}) => (
  <AnimatedContainer>
    <Flex
      css={{
        maxWidth: '1500px',
      }}
      mx="auto"
      px={[20, 30, 70]}
      my={[25, 30, 70]}
    >
      <ToggleButton
        className={activeItem === 0 && 'active'}
        onClick={() => setActiveItem(0)}
        py={[12, 12, 21]}
        width={1 / 2}
      >
        <Text
          fontFamily="sans"
          fontSize={[11, 11, 17]}
          letterSpacing={[0, 0.5]}
        >
          {firstItem}
        </Text>
      </ToggleButton>
      <ToggleButton
        className={activeItem === 1 && 'active'}
        onClick={() => setActiveItem(1)}
        py={[12, 12, 21]}
        width={1 / 2}
      >
        <Text
          fontFamily="sans"
          fontSize={[11, 11, 17]}
          letterSpacing={[0, 0.5]}
        >
          {secondItem}
        </Text>
      </ToggleButton>
    </Flex>
  </AnimatedContainer>
);

BookingToggle.propTypes = {
  activeItem: PropTypes.number.isRequired,
  firstItem: PropTypes.string.isRequired,
  secondItem: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
};

export default BookingToggle;
